import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { GridDataResult, PageChangeEvent, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import {
  orderBy,
  process,
  State,
  SortDescriptor,
  CompositeFilterDescriptor
} from '@progress/kendo-data-query';
import { Info } from '../../../../../core/common';
import { IPromoCode } from '../../../../../core/models';
import { PromoCodeService } from '../../../../../core/services/promo-code.service';
import { Subject } from 'rxjs';
import { AppNotifyService } from '../../../../../core/services/app-notify.service';
import { NotifyType } from 'src/app/core/enums/NotifyType';
import { Validators } from '@angular/forms';
import { disconnect } from 'process';

@Component({
  selector: 'app-promo-code',
  templateUrl: './promo-code.component.html',
  styleUrls: ['./promo-code.component.scss']
})
export class PromoCodeComponent implements OnInit {
  //#region member variable
  promoCodeGridView: GridDataResult;
  promoCodeLoading: boolean = false;

  today: Date = new Date(
    new Date().getFullYear(),
    new Date().getMonth(),
    new Date().getDate()
  );
  promoCodeForm: FormGroup;
  public isEditMode = false;
  isActiveFilterDropdown = [
    { text: 'No', value: false },   
    { text: 'Yes', value: true }
  ];

  allCustomersData: any[] = [];

  currencyList: any[] = [];

  filterTypeList = [
    'Region',
    'Territory',
    'Customer'
  ];

  selectionList: any[] = [];
  customerOneTimeUsageDialog = {
    opened: false
  };

  customerOneTimeUsageList: any[] = [];

  public finishList: any[] = [];
  public defaultFinish = {
    name: 'Select Finish',
    value: null
  };

  public extProductList: any[] = [];
  public bbProductList: any[] = [];
  public allProductList: any[] = [];
  public productDropdownList: any[] = [];

  public selectedProductCategory = 'EXT';
  public selectedProductNames = '';
  public selectedProductIds = '';
  public defaultProduct = {
    productName: 'Select Product',
    id: null
  };

  isActiveHeaderValue: boolean = false;

  saveInProcess: boolean;
  public infoMessage: Info = new Info();
  public inProgressMessage: boolean;
  public successMessage: boolean;
  public errorMessage: boolean;
  disableRegionTerritory = false;
  dateRangeFrom: Date;
  dateRangeTo: Date;
  //#endregion
  constructor(private formBuilder: FormBuilder, private promoCodeService: PromoCodeService, 
    private appNotifyService: AppNotifyService,

  ) { }
  onDiscountInput(event: any): void {
    let value = event.target.value;

    // Allow only digits and decimal point
    value = value.replace(/[^0-9.]/g, '');

    // Allow only one decimal point
    const parts = value.split('.');
    if (parts.length > 2) {
      value = parts[0] + '.' + parts[1];
    }

    // Restrict to 2 decimal places

    if (parts.length === 2) {
      value = parts[0] + '.' + parts[1].substring(0, 2);
    }

    event.target.value = value;

    this.promoCodeForm.get('discount')?.setValue(value, {
      emitEvent: false
    });
  }
  ngOnInit() {
    this.loadPromoCodeGrid();
    this.loadFinishes();
    this.loadCustomers();
    this.loadProducts();
    this.selectedProductCategory = 'EXT';
    this.onIsActiveHeaderChange(true);
    this.promoCodeForm = this.formBuilder.group({
      id: new FormControl(""),
      code: new FormControl(
        "",
        [
          Validators.required,
          Validators.maxLength(8),
        ]
      ),
      description: new FormControl(
        "",
        [
          Validators.required,
          Validators.maxLength(35)
        ]
      ),
      startDate: new FormControl(undefined, Validators.required),
      endDate: new FormControl(undefined, Validators.required),
      minPrice: new FormControl(""),
      maxPrice: new FormControl(""),
      productCategory: new FormControl('EXT', Validators.required),
      productType: new FormControl([], Validators.required),
      source: new FormControl(1, Validators.required),
      finish: new FormControl([], Validators.required),
      freeFreight: new FormControl(false, Validators.required),
      oneTime: new FormControl(false, Validators.required),
      discountType: new FormControl("Percentage", Validators.required),
      discount: new FormControl("", Validators.required),
      customerFilterType: new FormControl('Region'),
customerSelection: new FormControl([], Validators.required),
      currency: new FormControl([], Validators.required),
      isActive: new FormControl(true, Validators.required)
    });
    this.promoCodeForm.get('startDate')?.valueChanges.subscribe(startDate => {

      const endDate = this.promoCodeForm.get('endDate')?.value;

      if (startDate && endDate && new Date(endDate) < new Date(startDate)) {

        this.promoCodeForm.patchValue({
          endDate: null
        });

      }

    });
    this.promoCodeForm.get('freeFreight')?.valueChanges.subscribe((value: boolean) => {

      const discountControl = this.promoCodeForm.get('discount');
      const discountTypeControl = this.promoCodeForm.get('discountType');

      if (value === true) {
        discountControl.setValue('');
        discountControl.disable({ emitEvent: false });
        discountTypeControl.disable({ emitEvent: false });
      } else {
        discountControl.enable({ emitEvent: false });
        discountTypeControl.enable({ emitEvent: false });
      }
    });
    this.promoCodeForm.get('oneTime')?.valueChanges.subscribe((value: boolean) => {

      if (value === true) {

        this.promoCodeForm.patchValue({
          customerFilterType: 'Customer',
          customerSelection: []
        });

        this.onSelectionTypeChange('Customer');

        this.disableRegionTerritory = true;
      }
      else {

        this.promoCodeForm.patchValue({
          customerSelection: []
        });

        this.disableRegionTerritory = false;
      }
    });
  }
  //#region Grid data binding
  private loadPromoCodeGrid(): void {
    this.promoCodeLoading = true;   

    this.promoCodeService.getPromoCode().subscribe(
      (response: any[]) => {
        this.promoCodeService.promoCodes = response.map(item => ({
          id: item.id,
          code: item.code,
          description: item.description,
          productType: item.productType,
          productName: item.productName,
          productID: item.productID,
          source: item.source,

          finish: item.finish,
          freeFreight: item.freeFreight,
          oneTime: item.oneTime,
          discount: Number(item.discount),

          discountDisplay:
            item.discountType === '%'
              ? item.discount + '%'
              : '$' + item.discount,
          discountType: item.discountType,
          minPrice:
            item.minPrice === null ||
              item.minPrice === ''
              ? null
              : Number(item.minPrice),

          maxPrice:
            item.maxPrice === null ||
              item.maxPrice === ''
              ? null
              : Number(item.maxPrice),

          region:
            item.regionTerritoryCustomerNoType === 'Region'
              ? item.regionTerritoryCustomerNo
              : '-',

          territory:
            item.regionTerritoryCustomerNoType === 'Territory'
              ? item.regionTerritoryCustomerNo
              : '-',

          customerNo:
            item.regionTerritoryCustomerNoType === 'CustomerNo'
              ? item.regionTerritoryCustomerNo
              : '-',

          // KEEP THESE FOR EDIT
          regionTerritoryCustomerNoType:
            item.regionTerritoryCustomerNoType,

          regionTerritoryCustomerNo:
            item.regionTerritoryCustomerNo,

          startDate: new Date(item.startDate),
          endDate: new Date(item.endDate),

          dateRangeSort: new Date(item.startDate),
          currency: item.currency,
          isActive: item.isActive
        }));

        this.bindPromoCodeGrid();

        this.promoCodeLoading = false;  
      },
      (error) => {
        this.promoCodeLoading = false;  
      }
    );
  }


  //#endregion

  //#region label and variable declaration
  promoCodes = {
    promoCodeLbl: "Promo Code",
    promoCodeDescriptionLbl: "Promo Code Description",
    startDateLbl: "Start Date",
    endDateLbl: "End Date",
    minPriceLbl: "Min Value",
    maxPriceLbl: "Max Value",
    productTypeLbl: "Product Type",
    regionLbl: "Region",
    TerritoryLbl: "Territory",
    CustomerLbl: "Customer",
    isActiveLbl: "IsActive",
    actionLbl: "Action",
    isEmptyPromoCode: false,
    isEmptyPromoDescription: false,
    isEmptyStartDate: false,
    isEmptyEndDate: false,
    isSubmitted: false,
    todayDate: new Date(),
    isEndDateInValid:false
  }
  //#endregion
  //#region pagination, sorting,filtering for grid

  public promoCodeGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'promoCodeId',
      dir: 'desc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };
  private bindPromoCodeGrid(): void {
    
    const data = this.promoCodeService.promoCodes;
    this.promoCodeGridView = process(data, this.promoCodeGridstate);
  }

  protected promoCodeGridSortChange(sort: SortDescriptor[]): void {
    this.promoCodeGridstate.sort = sort;
    this.bindPromoCodeGrid();
  }
  protected promoCodeGridPageChange({ skip, take }: PageChangeEvent): void {
    this.promoCodeGridstate.skip = skip;
    this.promoCodeGridstate.take = take;
    this.bindPromoCodeGrid();
  }
  public promoCodeGridFilterChange(
    filter: CompositeFilterDescriptor
  ): void {

    this.promoCodeGridstate.filter = filter;
    this.promoCodeGridstate.skip = 0;

    this.bindPromoCodeGrid();
  }
  onIsActiveHeaderChange(value: boolean): void {
    this.isActiveHeaderValue = value;

    if (value === true) {
      this.promoCodeGridstate.filter = {
        logic: 'and',
        filters: []
      };
    } else {
      this.promoCodeGridstate.filter = {
        logic: 'and',
        filters: [
          {
            field: 'isActive',
            operator: 'eq',
            value: false
          }
        ]
      };
    }

    this.bindPromoCodeGrid();
  }

  //#endregion
  //#region Promo code dialog operation

  promoCodeDialog = {
    opened: false,
  }
  togglePromoCodeDialog() {
    this.promoCodeDialog.opened = !this.promoCodeDialog.opened;

    this.infoMessage = new Info();

    if (!this.promoCodeDialog.opened) {
      this.resetPromoCodeForm();
      this.isEditMode = false;
    } else {
      this.resetPromoCodeForm();
      this.isEditMode = false;

      this.promoCodeForm.patchValue({
        isActive: true,
        productCategory: 'EXT',
        productType: [],
        source: 1
      });

      this.selectedProductCategory = 'EXT';

      this.loadProducts();
    }
  }
  generatePromoCode(): void {

    this.promoCodeService.getAutoGeneratePromoCodes()
      .subscribe(
        (response) => {

          if (response && response.length > 0) {
            this.promoCodeForm.patchValue({
              code: response[0].promoCode
            });
          }

        },
        (error) => {
          console.error(error);
        }
      );
  }

  loadFinishes(): void {
    this.promoCodeService.getFinishes()
      .subscribe(response => {

        this.finishList = [{
          name: 'All',
          value: 'ALL'
        }];

        response.forEach(item => {
          this.finishList.push(item);
        });

      });
  }
  onFinishChange(values: string[]) {

    if (!values || values.length === 0) {
      return;
    }

    if (values.includes('ALL')) {

      this.promoCodeForm.patchValue({
        finish: ['ALL']
      }, { emitEvent: false });

      return;
    }
  }
  onProductChange(values: any[]) {

    const isAllSelected =
      this.selectedProductCategory === 'BB'
        ? values.includes(-1)
        : values.includes('All');

    if (isAllSelected) {

      this.promoCodeForm.patchValue({
        productType:
          this.selectedProductCategory === 'BB'
            ? [-1]
            : ['All']
      }, { emitEvent: false });

      this.selectedProductNames = 'ALL';
      this.selectedProductIds = 'ALL';

      return;
    }

    const source =
      this.selectedProductCategory === 'EXT'
        ? this.extProductList
        : this.selectedProductCategory === 'BB'
          ? this.bbProductList
          : this.allProductList;

    const selectedItems =
      this.selectedProductCategory === 'BB'
        ? source.filter(x => values.includes(x.id))
        : source.filter(x => values.includes(x.productName));

    this.selectedProductNames =
      selectedItems
        .map(x => x.productName)
        .join(',');

    this.selectedProductIds =
      selectedItems
        .map(x => x.id)
        .join(',');
  }
  loadProducts(): void {

    this.promoCodeService.getProductDetails()
      .subscribe(
        (response: any[]) => {

          this.extProductList = [{
            id: -1,
            productName: 'All',
            value: 'All'
          }];

          this.bbProductList = [{
            id: -1,
            productName: 'All'
          }];

          response.forEach(item => {

            if (item.productType === 'PSC') {

              this.extProductList.push(item);

            } else if (item.productType === 'B&P') {

              this.bbProductList.push(item);

            }

          });
          this.allProductList = [
            {
              id: -1,
              productName: 'All'
            }
          ];

          response.forEach(item => {
            this.allProductList.push(item);
          });
        },
        error => {
          console.error(error);
        }
      );
  }
  onProductCategoryChange(category: string): void {

    this.selectedProductCategory = category;

    this.promoCodeForm.patchValue({
      productType: []
    });

    this.selectedProductNames = '';
    this.selectedProductIds = '';
  }
  loadCustomers(): void {

    const userStorage = localStorage.getItem('user');
    const user = userStorage ? JSON.parse(userStorage) : null;
    const userName = user ? user.userName : '';

    this.promoCodeService
      .getRegionCurrencyList(userName)
      .subscribe((response: any[]) => {

        this.allCustomersData = response;

        const currencies = response
          .map(x => x.currencyCode || 'Null')
          .filter((value, index, self) =>
            self.indexOf(value) === index
          );

        this.currencyList = currencies.map(x => ({
          text: x,
          value: x
        }));

      });
  }
  edit(selectedCurrencies: string[]) {

    const filteredData = this.allCustomersData.filter(x =>
      selectedCurrencies.includes(x.currencyCode || 'Null')
    );

    const type =
      this.promoCodeForm?.get('customerFilterType')?.value
      || 'Region';

    if (type === 'Region') {

      const regions = [
        ...new Set(
          filteredData.map(x => x.defaultRegionCode)
        )
      ];

      this.selectionList = regions.map(x => ({
        text: x,
        value: x
      }));
    }

    if (type === 'Territory') {

      const territories = [
        ...new Set(
          filteredData.map(x => x.territoryDescription)
        )
      ];

      this.selectionList = territories.map(x => ({
        text: x,
        value: x
      }));
    }

    if (type === 'Customer') {

      const customers = [
        ...new Set(
          filteredData.map(x => x.customerNumber)
        )
      ];

      this.selectionList = [
        {
          text: 'All',
          value: 'ALL'
        }
      ];

      customers.forEach(x => {
        this.selectionList.push({
          text: x.toString(),
          value: x.toString()
        });
      });
    }
  }
  onCurrencyChange(selectedCurrencies: string[]) {

    const filteredData = this.allCustomersData.filter(x =>
      selectedCurrencies.includes(x.currencyCode || 'Null')
    );

    const uniqueRegions = [
      ...new Set(
        filteredData.map(x => x.defaultRegionCode || 'Null')
      )
    ];

   

    const uniqueTerritories = [
      ...new Set(
        filteredData.map(x => x.territoryDescription || 'Null')
      )
    ];

   

    this.promoCodeForm.patchValue({
      customerSelection: []
    });
    const type =
      this.promoCodeForm.get('customerFilterType')?.value;

    this.onSelectionTypeChange(type);
  }
  onSelectionTypeChange(type: string, clearSelection: boolean = false): void {
    

    const selectedCurrencies =
      this.promoCodeForm.get('currency')?.value || [];

    const filteredData = this.allCustomersData.filter(x =>
      selectedCurrencies.includes(x.currencyCode || 'Null')
    );

    if (type === 'Region') {

      const regions = [
        ...new Set(
          filteredData.map(x => x.defaultRegionCode)
        )
      ];

      this.selectionList = regions.map(x => ({
        text: x,
        value: x
      }));
    }

    if (type === 'Territory') {

      const territories = [
        ...new Set(
          filteredData.map(x => x.territoryDescription)
        )
      ];

      this.selectionList = territories.map(x => ({
        text: x,
        value: x
      }));
    }

    if (type === 'Customer') {

      const customers = [
        ...new Set(
          filteredData.map(x => x.customerNumber)
        )
      ];

      this.selectionList = [
        {
          text: 'All',
          value: 'ALL'
        }
      ];

      customers.forEach(x => {
        this.selectionList.push({
          text: x.toString(),
          value: x.toString()
        });
      });
    }

    if (clearSelection) {
      this.promoCodeForm.patchValue({
        customerSelection: []
      }, { emitEvent: false });
    }
  }
  onCustomerSelectionChange(values: string[]) {

    if (!values || values.length === 0) {
      return;
    }

    if (values.includes('ALL')) {

      this.promoCodeForm.patchValue({
        customerSelection: ['ALL']
      }, { emitEvent: false });

      return;
    }
  }
  
  editPromoCode(data: IPromoCode) {
    this.isEditMode = true;
    this.promoCodeDialog.opened = true;
    let freeFreight;
    let oneTime;
    let source;
    const discountValue = data.discount;

    const discountType =
      data.discountType === '%'
        ? 'Percentage'
        : 'Amount';
   
    if (data.freeFreight.toString() == 'Yes')
    {
      freeFreight = true;
    }
    else {
      freeFreight = false;
    }
    if (data.oneTime.toString() == 'Yes') {
      oneTime = true;
    }
    else {
      oneTime = false;
    }
    let filterType = 'Region';

    if (data.regionTerritoryCustomerNoType === 'Region') {
      filterType = 'Region';
    }
    else if (data.regionTerritoryCustomerNoType === 'Territory') {
      filterType = 'Territory';
    }
    else if (data.regionTerritoryCustomerNoType === 'CustomerNo') {
      filterType = 'Customer';
    }

    this.promoCodeForm.patchValue({
      customerFilterType: filterType
    });

    this.edit(
      data.currency
        ? data.currency.split(',')
        : []
    );

    const selectionValues =
      data.regionTerritoryCustomerNo
        ? data.regionTerritoryCustomerNo
          .split(',')
          .map(x => x.toString().trim())
        : [];
    if (data.source == 0) {
      source = 0;
    }
    else {
      source = 1;
    }
    this.promoCodeForm.patchValue({
      id: data.id,
      code: data.code,
      description: data.description,
      startDate: new Date(data.startDate),
      endDate: new Date(data.endDate),
      minPrice: data.minPrice ? Number(data.minPrice) : null,
      maxPrice: data.maxPrice ? Number(data.maxPrice) : null,
      productType:
        data.productType === 'EXT' || data.productType === 'ALL'
          ? (data.productName
            ? data.productName.split(',')
            : [])
          : (data.productID
            ? data.productID.split(',').map(x => Number(x))
            : []),
      productCategory:
        data.productType === 'ALL'
          ? 'ALL'
          : data.productType === 'B&P'
            ? 'BB'
            : 'EXT',


      finish:
        data.finish
          ? data.finish.split(',')
          : [],

      freeFreight: freeFreight,
      oneTime: oneTime,
      source: source,
      discount: discountValue,
      discountType: discountType,
      customerFilterType: filterType,
      customerSelection: selectionValues,
      currency: data.currency ? data.currency.split(',') : [],
      isActive: data.isActive
    });
    this.onSelectionTypeChange(filterType);

    this.promoCodeForm.patchValue({
      customerSelection: selectionValues
    });
    if (oneTime === true) {

      this.disableRegionTerritory = true;

      this.promoCodeForm.patchValue({
        customerFilterType: 'Customer'
      });

      this.onSelectionTypeChange('Customer');

      this.promoCodeForm.patchValue({
        customerSelection: selectionValues
      });
    }
    else {
      data.productType === 'EXT'
      this.disableRegionTerritory = false;
    }
    this.selectedProductNames = data.productName || '';
    this.selectedProductIds = data.productID || '';
    this.selectedProductCategory = 
      this.promoCodeForm.get('productCategory')?.value;
    if (this.selectedProductCategory === 'EXT') {
      this.productDropdownList = this.extProductList;
    }
    else if (this.selectedProductCategory === 'BB') {
      this.productDropdownList = this.bbProductList;
    }
    else {
      this.productDropdownList = this.allProductList;
    }
    this.promoCodeForm.updateValueAndValidity();
    const discountControl = this.promoCodeForm.get('discount');
    const discountTypeControl = this.promoCodeForm.get('discountType');

    if (freeFreight === true) {
      discountControl.setValue('');
      discountControl.disable({ emitEvent: false });

      discountTypeControl.disable({ emitEvent: false });
    } else {
      discountControl.enable({ emitEvent: false });

      discountTypeControl.enable({ emitEvent: false });
    }
  }

  
  resetPromoCodeForm() {
    this.promoCodes.isSubmitted = false;
    this.promoCodeForm.reset({
      productCategory: 'EXT',
      productType: [],
      finish: null,
      source: 1,
      customerFilterType: 'Region',
      customerSelection: [],
      isActive: true
    });

    this.selectedProductCategory = 'EXT';
    this.promoCodes.isEmptyPromoCode = false;
    this.promoCodes.isEmptyPromoDescription = false;
    this.promoCodes.isEmptyStartDate = false;
    this.promoCodes.isEmptyEndDate = false;
    this.promoCodes.isEndDateInValid = false;
    this.infoMessage = new Info();
    this.saveInProcess = false;
    this.promoCodeForm.get('discount').enable();
  }

  isFieldInvalid(fieldName: string): boolean {
    const field = this.promoCodeForm.get(fieldName);
    return field && field.invalid && this.promoCodes.isSubmitted;
  }

  public savePromoCode() {
    this.promoCodes.isSubmitted = true;
    this.promoCodeForm.markAllAsTouched();

    this.infoMessage.genericSuccess = "";
    this.infoMessage.genericError = "";
    this.infoMessage.genericInProgress = "";

    if (this.promoCodeForm.invalid) {

      Object.keys(this.promoCodeForm.controls).forEach(key => {

        const control = this.promoCodeForm.get(key);

        if (control && control.invalid) {
          console.log('INVALID =>', key, control.errors);
        }
      });

      this.infoMessage.genericError = "Please fill all the details";
      return;
    }

    const controls = this.promoCodeForm.controls;

    if (controls.startDate.value > controls.endDate.value) {
      this.infoMessage.genericError = "End Date should be greater than Start Date";
      return;
    }

    this.inProgressMessage = true;
    this.infoMessage.genericInProgress = this.infoMessage.inProgressMessage;
    this.saveInProcess = true;

    let discountValue = "";
    let discountType = "";
    if (controls.discount.value) {
      if (controls.discountType.value === "Percentage") {
        discountValue = controls.discount.value
        discountType = "%";
      } else {
        discountValue = controls.discount.value
        discountType = "$";
      }
    }
    const productTypeValue =
      this.selectedProductCategory === 'ALL'
        ? 'ALL'
        : this.selectedProductCategory === 'EXT'
          ? 'EXT'
          : 'B&P';
    let productIds = this.selectedProductIds;
    let productNames = this.selectedProductNames;

    if (this.selectedProductIds === 'ALL') {

      const source =
        this.selectedProductCategory === 'EXT'
          ? this.extProductList
          : this.selectedProductCategory === 'BB'
            ? this.bbProductList
            : this.allProductList;

      const allProducts = source.filter(x => x.id !== -1);

      productIds = allProducts.map(x => x.id).join(',');
      productNames = allProducts.map(x => x.productName).join(',');
    }

    let finishValue = '';

    if ((controls.finish.value || []).includes('ALL')) {

      finishValue = this.finishList
        .filter(x => x.value !== 'ALL')
        .map(x => x.value)
        .join(',');

    } else {

      finishValue = (controls.finish.value || []).join(',');
    }
    const selectionType =
      controls.customerFilterType.value;

    let selectedValues =
      controls.customerSelection.value || [];

    if (selectionType === 'Customer'
      && selectedValues.includes('ALL')) {

      selectedValues = this.selectionList
        .filter(x => x.value !== 'ALL')
        .map(x => x.value);
    }

    let regionTerritoryCustomerNoType = '';
    let regionTerritoryCustomerNo = '';

    switch (selectionType) {

      case 'Region':
        regionTerritoryCustomerNoType = 'Region';
        break;

      case 'Territory':
        regionTerritoryCustomerNoType = 'Territory';
        break;

      case 'Customer':
        regionTerritoryCustomerNoType = 'CustomerNo';
        break;
    }
    if (controls.minPrice.value == null) {
      var minPrice = controls.minPrice.value;
    }
    else {
      var minPrice = controls.minPrice.value.toString();
    }
    if (controls.maxPrice.value == null) {
      var maxPrice = controls.maxPrice.value;
    }
    else {
      var maxPrice = controls.maxPrice.value.toString();
    }

    regionTerritoryCustomerNo =
      selectedValues.join(',');
    
    const body: IPromoCode = {
      id: controls.id.value || 0,
      code: controls.code.value || "",
      description: controls.description.value || "",

      startDate: controls.startDate.value,
      endDate: controls.endDate.value,

      minPrice: minPrice || null,
      maxPrice: maxPrice || null,

      productType: productTypeValue,

      productName: productNames,

      productID: productIds,
      source: controls.source.value,

      finish: finishValue,
      freeFreight: controls.freeFreight.value || false,
      oneTime: controls.oneTime.value || false,
      discountType: discountType,
      discount: Number(discountValue),
      regionTerritoryCustomerNoType: regionTerritoryCustomerNoType,
regionTerritoryCustomerNo: regionTerritoryCustomerNo,
      currency: controls.currency.value ? controls.currency.value.join(',') : "",


      isActive: controls.isActive.value || false
    };
    if (body.id) {

      this.promoCodeService.updatePromoCode(body).subscribe(
        (response: any) => {
          if (response.data.id == 0) {
            alert("The PromoCode has not been updated yet.");
            return;
          }
          this.infoMessage.genericInProgress = "";
          this.saveInProcess = false;

          if (response) {
            this.resetPromoCodeForm();
            this.promoCodeDialog.opened = false;
            this.loadPromoCodeGrid();

            this.infoMessage.genericSuccess =
              "Promo Code updated successfully";
          }
        },
        (error) => {
          this.saveInProcess = false;
          this.infoMessage.genericError = "Something went wrong";
        }
      );
    } else {
      this.promoCodeService.savePromoCode(body).subscribe(
        (response: any) => {
          try {
            if (response[0].dataExist == "PromoCode already exists") {
              alert("PromoCode already exists");
              this.resetPromoCodeForm();
              this.promoCodeDialog.opened = false;
              this.loadPromoCodeGrid();
              return;
            }
          }
          catch (Exception) {

          }
          this.infoMessage.genericInProgress = "";
          this.saveInProcess = false;

          if (response) {
            this.resetPromoCodeForm();
            this.promoCodeDialog.opened = false;
            this.loadPromoCodeGrid();

            this.infoMessage.genericSuccess =
              "Promo Code saved successfully";
          }
        },
        (error) => {
          this.saveInProcess = false;
          this.infoMessage.genericError = "Something went wrong";
        }
      );

    }
  }
  //#endregion
  //endregion
  openCustomerOneTimeUsage(): void {

    this.customerOneTimeUsageDialog.opened = true;

    this.promoCodeService.getPromoCustomerList()
      .subscribe((response: any) => {

        this.customerOneTimeUsageList = response.map(x => ({
          customer: x.customer,
          promoCodeOneTimeUse:
            x.promoCodeOneTimeUse === '1'
        }));

      });
  }
  clearDateRangeFilter(): void {

    this.dateRangeFrom = null;
    this.dateRangeTo = null;

    this.bindPromoCodeGrid();
  }
  onDateRangeFilterChange(): void {

    const filteredData = this.promoCodeService.promoCodes.filter(x => {

      const startDate = new Date(x.startDate);
      const endDate = new Date(x.endDate);

      const fromMatch =
        !this.dateRangeFrom ||
        endDate >= this.dateRangeFrom;

      const toMatch =
        !this.dateRangeTo ||
        startDate <= this.dateRangeTo;

      return fromMatch && toMatch;
    });

    this.promoCodeGridView = process(
      filteredData,
      this.promoCodeGridstate
    );
  }
  closeCustomerOneTimeUsage(): void {
    this.customerOneTimeUsageDialog.opened = false;
  }

  //#region delete item
  public gridItemToRemove: any;
  public removeConfirmationSubject: Subject<boolean> = new Subject<boolean>();

  gridDelete = {
    label: {
      deleteConfirmLbl: 'Are you sure you want to delete promo code ',
      deleteYesLbl: 'Yes',
      deleteNoLbl: 'No',
      confirmLbl: 'Please confirm',
    }
  }


  public removeConfirmation(dataItem): Subject<boolean> {
    this.gridItemToRemove = dataItem; // show delete item confirmation box
    return this.removeConfirmationSubject;
  }

  protected confirmRemove(shouldRemove: boolean): void {
    if (shouldRemove) {
      this.removeConfirmationSubject.next(shouldRemove);
      this.RemoveHandler();
    }
    else {
      this.removeConfirmationSubject.next(shouldRemove);
      this.gridItemToRemove = null;
    }
  }
  protected RemoveHandler() {
    let freeFreight;
    let oneTime;
    if (this.gridItemToRemove.freeFreight == "Yes") {
      freeFreight = true
    }
    else {
      freeFreight = false
    }
    if (this.gridItemToRemove.oneTime == "Yes") {
      oneTime = true
    }
    else {
      oneTime = false
    }

    const body: IPromoCode = {
      id: this.gridItemToRemove.id,
      code: this.gridItemToRemove.code,
      description: this.gridItemToRemove.description,
      startDate: this.gridItemToRemove.startDate,
      endDate: this.gridItemToRemove.endDate,

      minPrice: this.gridItemToRemove.minPrice,
      maxPrice: this.gridItemToRemove.maxPrice,

      productType: this.gridItemToRemove.productType,

      source: this.gridItemToRemove.source,

      finish: this.gridItemToRemove.finish,
      freeFreight: freeFreight,
      oneTime: oneTime,
      discountType: this.gridItemToRemove.discountType,
      discount: Number(this.gridItemToRemove.discount),

      regionTerritoryCustomerNoType:
        
this.gridItemToRemove.regionTerritoryCustomerNoType,
      
 

regionTerritoryCustomerNo:
        
this.gridItemToRemove.regionTerritoryCustomerNo,
currency: this.gridItemToRemove.currency,


      isActive: this.gridItemToRemove.isActive
    };
    this.promoCodeService.deletePromoCode(body).subscribe((isRemoved: boolean) => {
      const Id = this.gridItemToRemove.id;
      this.gridItemToRemove = null;
      this.appNotifyService.notify(NotifyType.SUCCESS, "Selected promo code has been removed.");

      if (this.promoCodeService.promoCodes) {
        //This is a Local Remove
        const index = (this.promoCodeService.promoCodes).findIndex(r => r.id === Id);
        (this.promoCodeService.promoCodes).splice(index, 1);
        this.bindPromoCodeGrid();

      }



    }, error => {
      this.appNotifyService.notify(NotifyType.ERROR, 'An Error Occured');
    });
  }

  //#endregion
}
